import * as React from "react";
import { observer } from "mobx-react";
import { Button } from "./Button";
import { Strings } from "../Stores/StringsStore";

@observer
export class MoveButton extends Button {

	render() {
		return <Button {...this.props}>
			<i>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
					<polygon points="22 16 26 11 30 11 26 16 30 21 26 21 22 16" />
					<path d="M14,2V6H4V2H14m2-2H2V8H16V0h0Z" />
					<path d="M14,26v4H4V26H14m2-2H2v8H16V24h0Z" />
					<rect x="4" y="12" width="14" height="8" />
				</svg>
			</i>
		</Button>;
	}
}
